import {createBrowserRouter, createRoutesFromElements, Outlet, Route, RouterProvider} from "react-router-dom";
import Home from "./home/Home";
import Footer from "./components/Footer";
import Contact from "./components/Contact";
import Header from "./components/Header";
import About from "./components/About";
import Cards from "./components/Cards";
import ArtistsProfile from "./components/ArtistsProfile";
import ArtistRegistrationForm from "./pages/ArtistReg";
import AdminDashboard from "./Dashboard/AdminDashboard";
import AdminRegister from "./pages/AdminRegister";
import AdminLogin from "./pages/AdminLogin";
import ProtectedRoute from "./ProtectRoute";

const Layout = () => {
    return (
        <div>
            <Header />
            <Outlet />
            <Footer />
        </div>
    );
};

const AdminLayout = () => {
    return (
        <div>
            <Outlet />
        </div>
    );
};

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route>
            <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="about" element={<About />} />
                <Route path="artists" element={<Cards />} />
                <Route path="Apply Now" element={<ArtistRegistrationForm />} />
                <Route path="contact" element={<Contact />} />
                <Route path="events" element={<ArtistsProfile />} />
                <Route path="xtiim-artists/registration" element={<ArtistRegistrationForm />} />
            </Route>

            <Route
                path="/admin/dashboard"
                element={
                    <ProtectedRoute>
                        <AdminLayout />
                    </ProtectedRoute>
                }
            >
                <Route index element={<AdminDashboard />} />
            </Route>
            <Route path="register" element={<AdminRegister />} />
            <Route path="login" element={<AdminLogin />} />
        </Route>
    )
);

const App = () => {
    return <RouterProvider router={router} />;
};

export default App;
